import React, {Fragment} from "react";
import {
    Button,
    Col,
    Collapse,
    Descriptions,
    Divider,
    Dropdown,
    List,
    Menu, notification,
    Popconfirm,
    Row,
    Space,
    Tag,
    Tooltip, Typography
} from "antd";
import PermissionHidden from "../../../../components/permissions/PermissionHidden";
import {
    AlertOutlined,
    CommentOutlined,
    CreditCardOutlined,
    DeleteOutlined, EditOutlined,
    EnvironmentOutlined, FieldTimeOutlined, FileOutlined,
    HomeOutlined,
    HourglassOutlined,
    InfoCircleOutlined,
    LinkOutlined,
    MailOutlined,
    MergeCellsOutlined, MinusCircleOutlined,
    NodeIndexOutlined,
    PhoneOutlined,
    PlusOutlined, ReloadOutlined,
    RollbackOutlined, ScheduleOutlined,
    SkinOutlined,
    TagOutlined, VerticalAlignBottomOutlined
} from "@ant-design/icons";
import RestrictedHidden from "../../../../components/permissions/RestrictedHidden";
import {checkForfait, checkPermissions} from "../../../../components/permissions/functions";
import {APP_PREFIX_PATH, ASSET_BASE_URL} from "../../../../configs/AppConfig";
import ContactIcon from "../../../../components/util-components/ContactIcon";
import moment from "moment";
import IntlMessage from "../../../../components/util-components/IntlMessage";
import ApiService from "../../../../services/ApiService";
import ModalAdresseOpenWith from "../../../../modals/ModalAdresseOpenWith";
import ModalEditRoute from "../maps/ModalEditRoute";

const {Text, Title} = Typography

export class FicheAdresses extends React.Component {

    adresseOpenWith(item) {
        const {selected} = this.props

        const query = item.adresse + " " + item.postal + " " + item.ville + " " + (item.pays || "France")

        this.modalAdresseOpenWith.show(query, this.modalAdresseOpenWith.getContactAdresseLatLong(selected, query))
    }

    render() {
        const {selected, fiche} = this.props

        if (!selected) {
            return null
        }

        if (selected.adresses.length === 0) {
            return null
        }

        return (
            <Fragment>
                <Col>
                    <Col style={{display: "flex", justifyContent: "flex-end", marginBottom: 30}}>
                        <Button type="primary" icon={<PlusOutlined/>}
                                onClick={() => fiche.modalEditAdresse.show(selected.id)}>Ajouter un adresse</Button>
                    </Col>
                    {
                        selected.adresses.map((item, index) => {
                            return (
                                <Fragment key={index}>
                                    <Row style={{
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }}>
                                        <Space size="large">
                                            <Popconfirm
                                                title="Êtes-vous sûrs de vouloir supprimer cette adresse ?"
                                                onConfirm={() => fiche.onDelete(item.id, "adresse")}
                                                okText="Oui"
                                                cancelText="Non"
                                                okType={"danger"}
                                            >
                                                <Button danger type={"text"} icon={<MinusCircleOutlined/>}/>
                                            </Popconfirm>

                                            <Col>
                                                <Space>
                                                    <Text
                                                        strong>{item.nom} {item.siren && "(" + item.siren + ")"}</Text>
                                                    {item.route && (
                                                        <Tag style={{cursor: "pointer"}}
                                                             onClick={() => this.modalEditRoute.show(selected.id, item.id, item.route)}
                                                             color={"geekblue"}>{item.route}</Tag>
                                                    )}
                                                </Space>
                                                <a onClick={() => this.adresseOpenWith(item)}>
                                                    <Col>
                                                        {item.adresse}
                                                    </Col>
                                                    <Col>
                                                        {item.postal} - {item.ville} {item.pays || "France"}
                                                    </Col>
                                                </a>

                                                {item.note_adresse && (
                                                    <Col>
                                                        <Text type={"secondary"}>Note: {item.note_adresse}</Text>
                                                    </Col>
                                                )}

                                            </Col>
                                        </Space>


                                        <Button
                                            onClick={() => fiche.modalEditAdresse.show(selected.id, item)}
                                            icon={<EditOutlined/>} type={"text"}/>
                                    </Row>
                                    {selected.adresses.length > 1 && index < selected.adresses.length - 1 && (
                                        <Divider/>
                                    )}
                                </Fragment>

                            )
                        })
                    }
                </Col>
                <ModalAdresseOpenWith getRef={ref => this.modalAdresseOpenWith = ref}/>
                <ModalEditRoute getRef={ref => this.modalEditRoute = ref} onFinish={() => fiche.getData()}/>
            </Fragment>
        )
    }
}
